/* eslint-disable react-hooks/exhaustive-deps */
export default function useEventDetailsView(context) {
  const {
    AdminMemberProfileModal,
    ArtistBubbleView,
    CHAT_GROUP_EXECUTE_MODE,
    CHAT_GROUP_MODE,
    CHAT_GROUP_MODE_LABEL,
    DEFAULT_TITLE_STYLE,
    EventFlyerMedia,
    EventImageGallery,
    EventMaterialExplorer,
    EventMembersVisibilityConfirmModal,
    EventVenueDisplay,
    ExplanationButton,
    PersonAvatar,
    TASK_COMMENT_REACTION_OPTIONS,
    TASK_PRIORITY_LABELS,
    TASK_PRIORITY_ORDER,
    TASK_STATUS_LABELS,
    TASK_STATUS_OPTIONS,
    TicketLineChart,
    activeTimetableTab,
    addNotificationSilenceDraft,
    adjustmentsMap,
    applyRowAdjustments,
    assignedAdminsDisplay,
    assignmentButtonDisabled,
    assignmentButtonLabel,
    assignmentCandidatesLoading,
    assignmentDraftIds,
    assignmentSaving,
    assignmentSearch,
    assignmentSettingsOpen,
    bannerActionLoading,
    bannerUrl,
    buildHeaderGroups,
    buildParticipantProfile,
    buildPreviewColumns,
    buildPreviewRows,
    calcDueDays,
    canCancelEvent,
    canDownloadEventImages,
    canDownloadMaterials,
    canEditCastingSettings,
    canEditChatGroupSetting,
    canEditEventImages,
    canEditEventInfo,
    canEditMaterials,
    canEditParticipants,
    canEditTicketSales,
    canShareTicketSales,
    canEditGuestTickets,
    canManageGuestTicketAllocations,
    canEditTimetable,
    canUseEventChat,
    canViewCastingSettings,
    canViewContractStatus,
    canViewEventImages,
    canViewEventTasks,
    canViewMaterials,
    canViewParticipants,
    canViewTicketSales,
    canViewGuestTickets,
    canViewTimetable,
    cancelCompCalcBusy,
    cancelCompFixed,
    cancelCompLoading,
    cancelCompMode,
    cancelCompPercent,
    cancelCompSaving,
    cancelCompTargets,
    cancelReason,
    channelShares,
    chatGroupConfirmState,
    chatGroupCurrentMode,
    chatGroupDraftChanged,
    chatGroupDraftMode,
    chatGroupPreviewLoading,
    chatGroupSaving,
    chatGroupSettingLoading,
    chatGroupUpdatedAtLabel,
    closeCancelCompModal,
    closeCancelModal,
    closeChatGroupConfirmModal,
    closeEventTaskDetailModal,
    closeManualParticipantModal,
    closeMembersVisibilityConfirmModal,
    conciergeApplication,
    contractStatusSummary,
    contractTableRows,
    currentFlyerUrl,
    ensureEventTaskProject,
    eventData,
    eventFinanceSummary,
    eventFinanceSummaryLoading,
    eventFinanceVisual,
    eventId,
    eventReadOnlyTitle,
    eventSubtaskInlineEdit,
    eventTaskAddingDependency,
    eventTaskAddingDependencyTaskId,
    eventTaskAllTasksLoading,
    eventTaskAssignableAdmins,
    eventTaskAttachmentBlockRef,
    eventTaskAttachmentInputRef,
    eventTaskAttachments,
    eventTaskAttachmentsLoading,
    eventTaskCanEdit,
    eventTaskCommentReactionBusyMap,
    eventTaskCreating,
    eventTaskCreatingSubtask,
    eventTaskDeletingAttachmentId,
    eventTaskDependencies,
    eventTaskDependenciesLoading,
    eventTaskDependencyBlockRef,
    eventTaskDependencyCandidateTasks,
    eventTaskDependencyLinkType,
    eventTaskDependencyPickerFocused,
    eventTaskDependencyQuery,
    eventTaskDetailAssigneeAvatarUrl,
    eventTaskDetailAssigneeLabel,
    eventTaskDetailHasAssignee,
    eventTaskDetailCommentBody,
    eventTaskDetailComments,
    eventTaskDetailCommentsLoading,
    eventTaskDetailDeleting,
    eventTaskDetailDueMeta,
    eventTaskDetailFeedTab,
    eventTaskDetailForm,
    eventTaskDetailModal,
    eventTaskDetailParentTask,
    eventTaskDetailPostingComment,
    eventTaskDetailSaving,
    eventTaskDetailSectionName,
    eventTaskDetailSubtasks,
    eventTaskDetailTask,
    eventTaskError,
    eventTaskInsights,
    eventTaskLoading,
    eventTaskMetaEditField,
    eventTaskNewSubtaskAssigneeId,
    eventTaskNewSubtaskAssigneeLabel,
    eventTaskNewSubtaskDueOn,
    eventTaskNewSubtaskInlineEditField,
    eventTaskNewSubtaskTitle,
    eventTaskProject,
    eventTaskRemovingDependencyTaskId,
    eventTaskSectionNameMap,
    eventTaskUpdatingId,
    eventTaskUploadingAttachment,
    filteredAssignmentCandidates,
    flyerActionLoading,
    flyerSideText,
    flyerToggleLabel,
    flyerUrls,
    formatAdminDisplay,
    formatCurrency,
    formatDate,
    formatDateTimeJST,
    formatDueHint,
    formatFileSize,
    formatTicketPrice,
    formatTicketQuantity,
    formatTime,
    formatYenText,
    genres,
    getDefaultColumnAlign,
    getEventTaskAssigneeLabel,
    getEventTaskCommentAuthorAvatarUrl,
    getEventTaskCommentAuthorName,
    getEventTaskPrimaryAssignee,
    getParticipantImageStyle,
    getPerformanceVenueInfo,
    goContractDetail,
    grossRevenue,
    groupEventRows,
    groupEventsLoading,
    groupRootPerformanceLabel,
    groupedStageSeatingSummary,
    handleAddEventTaskDependency,
    handleAddManualParticipant,
    handleApplyCancelCompBulk,
    handleAssignmentSettingsSave,
    handleBannerDelete,
    handleCreateEventSubtask,
    handleDeleteEventTaskAttachment,
    handleDeleteEventTaskDetail,
    handleDownloadEventTaskAttachment,
    handleFlyerDelete,
    handleFlyerPopupInnerClick,
    handleMembersVisibilityConfirmGroupAll,
    handleMembersVisibilityConfirmSingle,
    handleMembersVisibilityToggle,
    handlePerformanceFlyerDelete,
    handlePostEventTaskComment,
    handleRemoveEventTaskDependency,
    handleRemoveEventTaskSuccessor,
    handleRemoveManualParticipant,
    handleSaveEventTaskDescription,
    handleToggleEventTaskCommentReaction,
    handleToggleEventTaskStatus,
    handleUploadEventTaskAttachment,
    hasMultipleFlyers,
    headerEventDateLabel,
    hoveredPreviewRowId,
    infoPublishAtLabel,
    isConciergeEvent,
    isCurrentEventGroupRoot,
    isEventCancelled,
    isInfoExplicitlyUnpublished,
    isMultiPerformanceEvent,
    isProgressComplete,
    isTaskDoneStatus,
    isToday,
    jstTodayYmd,
    labelStatus,
    linePoints,
    loggedInAdminId,
    manualParticipantCandidates,
    manualParticipantLoading,
    manualParticipantModalOpen,
    manualParticipantRemovingId,
    manualParticipantSavingId,
    manualParticipantSearch,
    mapEventTaskCommentReactions,
    mapLinkUrl,
    membersVisibilityButtonClass,
    membersVisibilityButtonLabel,
    membersVisibilityConfirmState,
    membersVisibilitySaving,
    membersVisibleToArtists,
    memoMap,
    multiPerformanceRows,
    navigate,
    netRevenue,
    normalizeEventTaskStatus,
    normalizeTaskPriority,
    notificationSilenceDrafts,
    notificationSilenceLoading,
    notificationSilenceModalOpen,
    notificationSilenceSaving,
    notificationSilenceSummary,
    nowTimetableRowId,
    openAssignmentSettings,
    openCancelCompModal,
    openCancelModal,
    openCastingShortcut,
    openChat,
    openChatGroupConfirmModal,
    openEventTaskDetailModal,
    openFlyerPreview,
    openManualParticipantModal,
    openNotificationSilenceModal,
    openTimetableViewer,
    parentEventLabel,
    parentEventLink,
    parsePgIntArray,
    participantBubbleArtists,
    participantProfile,
    participantSections,
    participantSummary,
    participantView,
    patchEventTaskInline,
    performanceFlyerLoading,
    performanceTypeJapanese,
    pickColumnWidths,
    pickRowHeights,
    pickTitleStyle,
    pinnedPreviewRowIds,
    plannedCancelCompByContractArtistId,
    proceedCancelPreview,
    progressOverviewItems,
    progressPct,
    promptBannerUpload,
    promptFlyerUpload,
    promptPerformanceFlyerUpload,
    recentStats,
    removeNotificationSilenceDraft,
    renderGenreBadges,
    renderGroupEventRow,
    renderInheritanceNotice,
    renderMultilineText,
    runtimeData,
    saveNotificationSilence,
    selectedMultiPerformance,
    selectedMultiPerformanceFlyerUrl,
    selectedMultiPerformancePlaceholderEvent,
    setActiveTimetableTab,
    setAssignmentSearch,
    setAssignmentSettingsOpen,
    setCancelCompFixed,
    setCancelCompMode,
    setCancelCompPercent,
    setCancelCompTargets,
    setCancelReason,
    setChatGroupDraftMode,
    setEventSubtaskInlineEdit,
    setEventTaskDependencyLinkType,
    setEventTaskDependencyPickerFocused,
    setEventTaskDependencyQuery,
    setEventTaskDetailCommentBody,
    setEventTaskDetailFeedTab,
    setEventTaskDetailForm,
    setEventTaskMetaEditField,
    setEventTaskNewSubtaskAssigneeId,
    setEventTaskNewSubtaskDueOn,
    setEventTaskNewSubtaskInlineEditField,
    setEventTaskNewSubtaskTitle,
    setHoveredPreviewRowId,
    setManualParticipantSearch,
    setNotificationSilenceModalOpen,
    setParticipantProfile,
    setParticipantView,
    setPinnedPreviewRowIds,
    setSelectedMultiPerformanceId,
    setShowFlyerPopup,
    shouldShowGroupEventsPanel,
    shouldShowProgressOverview,
    showCancelCompModal,
    showCancelConfirm,
    showCancelModal,
    showFlyerPopup,
    soldTotal,
    stageSeatingSummary,
    stageSeatingSummaryLoading,
    subTitleText,
    submitCancel,
    submitChatGroupModeChange,
    submittingCancel,
    ticketCapacityProgress,
    ticketSites,
    ticketSummary,
    ticketSummaryLoading,
    fetchTicketSalesSummary,
    tickets,
    timetableLoading,
    timetables,
    titleText,
    toggleAssignmentDraftId,
    toggleFlyerFace,
    totalCapacity,
    unread,
    updateNotificationSilenceDraft,
    usesParentAssets,
    vendors,
    venueDisplayName,
    venueId,
    venueLink,
    venueResolvedAddress,
  } = context;
    const eventDetailsView = {
      AdminMemberProfileModal,
      ArtistBubbleView,
      CHAT_GROUP_EXECUTE_MODE,
      CHAT_GROUP_MODE,
      CHAT_GROUP_MODE_LABEL,
      EventFlyerMedia,
      EventImageGallery,
      EventMaterialExplorer,
      EventMembersVisibilityConfirmModal,
      EventVenueDisplay,
      setPinnedPreviewRowIds,
      setHoveredPreviewRowId,
      runtimeData,
      pinnedPreviewRowIds,
      pickTitleStyle,
      pickRowHeights,
      pickColumnWidths,
      nowTimetableRowId,
      memoMap,
      hoveredPreviewRowId,
      getDefaultColumnAlign,
      buildPreviewRows,
      buildPreviewColumns,
      buildHeaderGroups,
      applyRowAdjustments,
      adjustmentsMap,
      DEFAULT_TITLE_STYLE,
      ExplanationButton,
      PersonAvatar,
      TASK_COMMENT_REACTION_OPTIONS,
      TASK_PRIORITY_LABELS,
      TASK_PRIORITY_ORDER,
      TASK_STATUS_LABELS,
      TASK_STATUS_OPTIONS,
      TicketLineChart,
      activeTimetableTab,
      addNotificationSilenceDraft,
      assignedAdminsDisplay,
      assignmentButtonDisabled,
      assignmentButtonLabel,
      assignmentCandidatesLoading,
      assignmentDraftIds,
      assignmentSaving,
      assignmentSearch,
      assignmentSettingsOpen,
      bannerActionLoading,
      bannerUrl,
      buildParticipantProfile,
      calcDueDays,
      canCancelEvent,
      canEditCastingSettings,
      canEditChatGroupSetting,
      canEditEventInfo,
      canEditMaterials,
      canEditEventImages,
      canEditParticipants,
      canEditTicketSales,
      canShareTicketSales,
      canEditGuestTickets,
      canManageGuestTicketAllocations,
      canEditTimetable,
      canUseEventChat,
      canViewCastingSettings,
      canViewContractStatus,
      canViewEventTasks,
      canViewEventImages,
      canDownloadEventImages,
      canDownloadMaterials,
      canViewMaterials,
      canViewParticipants,
      canViewTicketSales,
      canViewGuestTickets,
      canViewTimetable,
      cancelCompCalcBusy,
      cancelCompFixed,
      cancelCompLoading,
      cancelCompMode,
      cancelCompPercent,
      cancelCompSaving,
      cancelCompTargets,
      cancelReason,
      channelShares,
      chatGroupConfirmState,
      chatGroupCurrentMode,
      chatGroupDraftChanged,
      chatGroupDraftMode,
      chatGroupPreviewLoading,
      chatGroupSaving,
      chatGroupSettingLoading,
      chatGroupUpdatedAtLabel,
      closeCancelCompModal,
      closeCancelModal,
      closeChatGroupConfirmModal,
      closeEventTaskDetailModal,
      closeManualParticipantModal,
      closeMembersVisibilityConfirmModal,
      conciergeApplication,
      contractStatusSummary,
      contractTableRows,
      currentFlyerUrl,
      ensureEventTaskProject,
      eventData,
      eventFinanceSummary,
      eventFinanceSummaryLoading,
      eventFinanceVisual,
      eventId,
      eventReadOnlyTitle,
      eventSubtaskInlineEdit,
      eventTaskAddingDependency,
      eventTaskAddingDependencyTaskId,
      eventTaskAllTasksLoading,
      eventTaskAssignableAdmins,
      eventTaskAttachmentBlockRef,
      eventTaskAttachmentInputRef,
      eventTaskAttachments,
      eventTaskAttachmentsLoading,
      eventTaskCanEdit,
      eventTaskCommentReactionBusyMap,
      eventTaskCreating,
      eventTaskCreatingSubtask,
      eventTaskDeletingAttachmentId,
      eventTaskDependencies,
      eventTaskDependenciesLoading,
      eventTaskDependencyBlockRef,
      eventTaskDependencyCandidateTasks,
      eventTaskDependencyLinkType,
      eventTaskDependencyPickerFocused,
      eventTaskDependencyQuery,
      eventTaskDetailAssigneeAvatarUrl,
      eventTaskDetailAssigneeLabel,
      eventTaskDetailHasAssignee,
      eventTaskDetailCommentBody,
      eventTaskDetailComments,
      eventTaskDetailCommentsLoading,
      eventTaskDetailDeleting,
      eventTaskDetailDueMeta,
      eventTaskDetailFeedTab,
      eventTaskDetailForm,
      eventTaskDetailModal,
      eventTaskDetailParentTask,
      eventTaskDetailPostingComment,
      eventTaskDetailSaving,
      eventTaskDetailSectionName,
      eventTaskDetailSubtasks,
      eventTaskDetailTask,
      eventTaskError,
      eventTaskInsights,
      eventTaskLoading,
      eventTaskMetaEditField,
      eventTaskNewSubtaskAssigneeId,
      eventTaskNewSubtaskAssigneeLabel,
      eventTaskNewSubtaskDueOn,
      eventTaskNewSubtaskInlineEditField,
      eventTaskNewSubtaskTitle,
      eventTaskProject,
      eventTaskRemovingDependencyTaskId,
      eventTaskSectionNameMap,
      eventTaskUpdatingId,
      eventTaskUploadingAttachment,
      filteredAssignmentCandidates,
      flyerActionLoading,
      flyerSideText,
      flyerToggleLabel,
      flyerUrls,
      formatAdminDisplay,
      formatCurrency,
      formatDate,
      formatDateTimeJST,
      formatDueHint,
      formatFileSize,
      formatTicketPrice,
      formatTicketQuantity,
      formatTime,
      formatYenText,
      genres,
      getEventTaskAssigneeLabel,
      getEventTaskCommentAuthorAvatarUrl,
      getEventTaskCommentAuthorName,
      getEventTaskPrimaryAssignee,
      getParticipantImageStyle,
      getPerformanceVenueInfo,
      goContractDetail,
      grossRevenue,
      groupEventRows,
      groupEventsLoading,
      groupRootPerformanceLabel,
      groupedStageSeatingSummary,
      handleAddEventTaskDependency,
      handleAddManualParticipant,
      handleApplyCancelCompBulk,
      handleAssignmentSettingsSave,
      handleBannerDelete,
      handleCreateEventSubtask,
      handleDeleteEventTaskAttachment,
      handleDeleteEventTaskDetail,
      handleDownloadEventTaskAttachment,
      handleFlyerDelete,
      handleFlyerPopupInnerClick,
      handleMembersVisibilityConfirmGroupAll,
      handleMembersVisibilityConfirmSingle,
      handleMembersVisibilityToggle,
      handlePerformanceFlyerDelete,
      handlePostEventTaskComment,
      handleRemoveEventTaskDependency,
      handleRemoveEventTaskSuccessor,
      handleRemoveManualParticipant,
      handleSaveEventTaskDescription,
      handleToggleEventTaskCommentReaction,
      handleToggleEventTaskStatus,
      handleUploadEventTaskAttachment,
      hasMultipleFlyers,
      headerEventDateLabel,
      infoPublishAtLabel,
      isConciergeEvent,
      isCurrentEventGroupRoot,
      isEventCancelled,
      isInfoExplicitlyUnpublished,
      isMultiPerformanceEvent,
      isProgressComplete,
      isTaskDoneStatus,
      isToday,
      jstTodayYmd,
      labelStatus,
      linePoints,
      loggedInAdminId,
      manualParticipantCandidates,
      manualParticipantLoading,
      manualParticipantModalOpen,
      manualParticipantRemovingId,
      manualParticipantSavingId,
      manualParticipantSearch,
      mapEventTaskCommentReactions,
      mapLinkUrl,
      membersVisibilityButtonClass,
      membersVisibilityButtonLabel,
      membersVisibilityConfirmState,
      membersVisibilitySaving,
      membersVisibleToArtists,
      multiPerformanceRows,
      navigate,
      netRevenue,
      normalizeEventTaskStatus,
      normalizeTaskPriority,
      notificationSilenceDrafts,
      notificationSilenceLoading,
      notificationSilenceModalOpen,
      notificationSilenceSaving,
      notificationSilenceSummary,
      openAssignmentSettings,
      openCancelCompModal,
      openCancelModal,
      openCastingShortcut,
      openChat,
      openChatGroupConfirmModal,
      openEventTaskDetailModal,
      openFlyerPreview,
      openManualParticipantModal,
      openNotificationSilenceModal,
      openTimetableViewer,
      parentEventLabel,
      parentEventLink,
      parsePgIntArray,
      participantBubbleArtists,
      participantProfile,
      participantSections,
      participantSummary,
      participantView,
      patchEventTaskInline,
      performanceFlyerLoading,
      performanceTypeJapanese,
      plannedCancelCompByContractArtistId,
      proceedCancelPreview,
      progressOverviewItems,
      progressPct,
      promptBannerUpload,
      promptFlyerUpload,
      promptPerformanceFlyerUpload,
      recentStats,
      removeNotificationSilenceDraft,
      renderGenreBadges,
      renderGroupEventRow,
      renderInheritanceNotice,
      renderMultilineText,
      saveNotificationSilence,
      selectedMultiPerformance,
      selectedMultiPerformanceFlyerUrl,
      selectedMultiPerformancePlaceholderEvent,
      setActiveTimetableTab,
      setAssignmentSearch,
      setAssignmentSettingsOpen,
      setCancelCompFixed,
      setCancelCompMode,
      setCancelCompPercent,
      setCancelCompTargets,
      setCancelReason,
      setChatGroupDraftMode,
      setEventSubtaskInlineEdit,
      setEventTaskDependencyLinkType,
      setEventTaskDependencyPickerFocused,
      setEventTaskDependencyQuery,
      setEventTaskDetailCommentBody,
      setEventTaskDetailFeedTab,
      setEventTaskDetailForm,
      setEventTaskMetaEditField,
      setEventTaskNewSubtaskAssigneeId,
      setEventTaskNewSubtaskDueOn,
      setEventTaskNewSubtaskInlineEditField,
      setEventTaskNewSubtaskTitle,
      setManualParticipantSearch,
      setNotificationSilenceModalOpen,
      setParticipantProfile,
      setParticipantView,
      setSelectedMultiPerformanceId,
      setShowFlyerPopup,
      shouldShowGroupEventsPanel,
      shouldShowProgressOverview,
      showCancelCompModal,
      showCancelConfirm,
      showCancelModal,
      showFlyerPopup,
      soldTotal,
      stageSeatingSummary,
      stageSeatingSummaryLoading,
      subTitleText,
      submitCancel,
      submitChatGroupModeChange,
      submittingCancel,
      ticketCapacityProgress,
      ticketSites,
      ticketSummary,
      ticketSummaryLoading,
      fetchTicketSalesSummary,
      tickets,
      timetableLoading,
      timetables,
      titleText,
      toggleAssignmentDraftId,
      toggleFlyerFace,
      totalCapacity,
      unread,
      updateNotificationSilenceDraft,
      usesParentAssets,
      vendors,
      venueDisplayName,
      venueId,
      venueLink,
      venueResolvedAddress,
    };
  return {
    eventDetailsView,
  };
}
